module.exports = __webpack_public_path__ + "img/newicon3click.3b47287f.svg";